import React from 'react';
import { Link } from 'react-router-dom';
import { getProjectTypeLabel } from '../../common/constants';
import HTMLReactParser from 'html-react-parser';

const ProjectHosting = ({ orgClient, project }) => {
  const { subscription } = orgClient;
  return (
    <>
      <div className="card-header">
        <h4>Project Cloud Hosting</h4>
      </div>
      <hr className="dark horizontal " style={{ marginTop: '-12px' }} />
      <div className="card-body">
        {subscription === 'BUILDER_FREE' && (
          <>
            <div className="alert alert-warning rounded text-white align-items-center">
              <i className="material-icons">warning</i>&nbsp;
              {HTMLReactParser(
                `This account doesn't have any subscription plan.<br/>&nbsp;Please upgrade your account to access premium features.`,
              )}
            </div>
          </>
        )}
        {subscription !== 'BUILDER_FREE' && (
          <div>
            Current Hosting Plan:&nbsp;
            <b>
              {subscription === 'UNLIMITED'
                ? 'Unlimited'
                : getProjectTypeLabel(project.projectType)}
            </b>
          </div>
        )}
        <hr className="dark horizontal " />
        {subscription !== 'BUILDER_FREE' && subscription !== 'UNLIMITED' && (
          <Link to={`/${project.uuid}/cloud-hosting`} className="btn btn-sm btn-outline-dark">
            Upgrade
          </Link>
        )}
      </div>
    </>
  );
};

export default ProjectHosting;
